module.exports = __webpack_public_path__ + "img/social-links.38015870.svg";